import { Component, OnInit } from '@angular/core';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { Preset } from 'src/app/models/preset.model';
import { LanguageService, NotificationService } from 'src/app/services';
import { ApiPresetsService } from 'src/app/services/api-presets.service';

@Component({
  selector: 'app-presets-list',
  templateUrl: './presets-list.component.html',
  styleUrls: ['./presets-list.component.css']
})
export class PresetsListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  presets: Preset[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiPresets: ApiPresetsService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
   getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.presets = [];

    this.setListParams();

    this.apiPresets.getList(this.listParams).subscribe((response: Res) => {
      console.log("PRESETS_RESPONSE_LIST: ", response)

      if (response != null && response.result != null) {

        this.presets = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        name: ''
      },
      object: 'attrs_presets',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   * @param event 
   */
   pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /**
  * 
  * @param ids 
  */
   onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiPresets.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.presets.filter(val => val.checked).map(({ id }) => id))];
    this.onDelete(ids);
  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
   selectedCheckBox(index: number, event: any): void {

    this.presets[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.presets.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.presets.length == 0) return false;

    return this.presets.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.presets.length;
    let pc = this.presets.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {
    
    let pc = this.presets.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }


}
